import api, { getData } from '@/axiosConfig'
import { status } from '../../helpers'
import { deconstructIntegration } from '@/state/deconstructionFunctions'
const gemnoteAPI = api()
import i18n from '../../internatinalization/i18n'

import {
  START_LOAD_INTEGRATIONS,
  END_LOAD_INTEGRATIONS,
  SET_INTEGRATIONS,
  SET_SALESFORCE_RECORS,
  LOAD_SALESFORCE_BY_RESOURCE_TYPE,
  RESET_INTEGRATIONS_STATE,
  REMOVE_SALESFORCE_INTEGRATION
} from '@/state/mutationTypes'

export default {
  async getIntegrationsListForUser({ commit, dispatch }, userId) {
    try {
      commit(START_LOAD_INTEGRATIONS)
      const response = await gemnoteAPI.get(`team/users/${userId}/integrations`)
      const data = getData(response)
      let resultingIntegrations = data.map(integration =>
        deconstructIntegration(integration)
      )
      commit(SET_INTEGRATIONS, resultingIntegrations)
      commit(END_LOAD_INTEGRATIONS)
    } catch (error) {
      console.log(error)
      commit(SET_INTEGRATIONS, [])
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('integrations.action.get-integrations-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async setUserSalesforceOath2({ dispatch, rootState }, salesForceCode) {
    const requestParams = {
      integration: {
        provider: 'salesforce',
        code: salesForceCode
      }
    }
    try {
      await gemnoteAPI.post('team/integrations/oauth2', requestParams)
      dispatch('getIntegrationsListForUser', rootState.profile.user.id)
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('integrations.action.save-oauth2-token-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async searchSalesForceByResourceType(
    { commit, rootState, dispatch },
    resourceType
  ) {
    try {
      commit(LOAD_SALESFORCE_BY_RESOURCE_TYPE, status.LOADING)
      dispatch('order/setSalesforceResorceType', '', { root: true })
      dispatch('order/setSalesforceRecordUID', null, { root: true })
      const response = await gemnoteAPI.get(
        `team/users/${rootState.profile.user.id}/salesforce?resource_type=${resourceType}`
      )
      commit(SET_SALESFORCE_RECORS, [])
      let foundRecords = []

      switch (resourceType) {
        case 'Lead':
          // eslint-disable-next-line no-case-declarations
          let leadResults = response.data['Leads']
          leadResults = leadResults.map(lead => {
            return {
              label: `${lead.name} - ${lead.company}`,
              code: lead.uid
            }
          })

          foundRecords = leadResults
          break

        case 'Account':
          // eslint-disable-next-line no-case-declarations
          let accountResults = response.data['Accounts']
          accountResults = accountResults.map(account => {
            return {
              label: `${account.name}`,
              code: account.uid
            }
          })

          foundRecords = accountResults
          break

        case 'Contact':
          // eslint-disable-next-line no-case-declarations
          let contactResults = response.data['Contacts']
          contactResults = contactResults.map(contact => {
            return {
              label: `${contact.name} - ${contact.account_name}`,
              code: contact.uid
            }
          })

          foundRecords = contactResults
          break
      }

      dispatch('order/setSalesforceResorceType', resourceType, { root: true })
      commit(SET_SALESFORCE_RECORS, foundRecords)
      commit(LOAD_SALESFORCE_BY_RESOURCE_TYPE, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_SALESFORCE_BY_RESOURCE_TYPE, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('integrations.action.search-salesforce-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async disconnectFromSalesForce(
    { commit, dispatch, rootState },
    salesforceId
  ) {
    try {
      await gemnoteAPI.delete(
        `team/users/${rootState.profile.user.id}/integrations/${salesforceId}`
      )
      commit(REMOVE_SALESFORCE_INTEGRATION, salesforceId)
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('integrations.action.salesforce-disconnect-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  resetIntegrationsState({ commit }) {
    commit(RESET_INTEGRATIONS_STATE)
  }
}
